import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  LOAD_VIOLATION_LIST,
  CREATE_VIOLATION,
  EDIT_VIOLATION_BY_ID,
  LOAD_VIOLATION_BY_ID,
  DELETE_VIOLATION,
  GENERATE_VIOLATION_PROTOCOL_PDF,
} from './actions';
import { VIOLATIONS_MODULE } from '../../configs/moduleNames';
import {
  createLoadListReducerWithBegin,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';

const initialState = {
  violationListMeta: {},
  loadingViolationList: false,
  violationList: [],
  loadingCurrentViolation: false,
  currentViolation: {},
  loadingCreateViolation: false,
  loadingEditViolationById: false,
  loadingDeleteViolation: false,
  loadingGenerateViolationProtocolPdf: false,
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(VIOLATIONS_MODULE + LOAD_VIOLATION_LIST, 'violationList', 'loadingViolationList'),
  ...updateLoadParameterReducer(VIOLATIONS_MODULE + LOAD_VIOLATION_BY_ID, 'currentViolation', 'loadingCurrentViolation', {}),
  ...createOperationStateReducer(VIOLATIONS_MODULE + CREATE_VIOLATION, 'loadingCreateViolation'),
  ...createOperationStateReducer(VIOLATIONS_MODULE + EDIT_VIOLATION_BY_ID, 'loadingEditViolationById'),
  ...createOperationStateReducer(VIOLATIONS_MODULE + DELETE_VIOLATION, 'loadingDeleteViolation'),
  ...createOperationStateReducer(VIOLATIONS_MODULE + GENERATE_VIOLATION_PROTOCOL_PDF, 'loadingGenerateViolationProtocolPdf'),
}, initialState);

export default reducer;

export const getViolationData = createSelector(
  [state => state[VIOLATIONS_MODULE]],
  state => {
    const {
      violationListMeta,
      loadingViolationList,
      violationList,
      loadingCurrentViolation,
      currentViolation,
      loadingCreateViolation,
      loadingEditViolationById,
      loadingDeleteViolation,
      loadingGenerateViolationProtocolPdf,
    } = state;
    return {
      violationListMeta,
      loadingViolationList,
      violationList,
      loadingCurrentViolation,
      currentViolation,
      loadingCreateViolation,
      loadingEditViolationById,
      loadingDeleteViolation,
      loadingGenerateViolationProtocolPdf,
    };
  },
);
